export default __webpack_public_path__ + "static/media/fingo-mobile-2.6af0b49d.png";